import React  from "react";
export default function Applications() {
    return (<div>Applications</div>);
}